import axios from "axios";

export const API_URL = "/api";

export const apiRequest = async ({ method, path, ...config }) => {
  const response = await axios({
    method,
    url: `${API_URL}/${path}`,
    data: config.body ? config.body : undefined,
    withCredentials: true
  });
  return response.data.data;
};

export const apiRequestOnline = async ({ method, path, ...config }) => {
  try {
    const response = await axios({
      method,
      url: `https://lsaran.online/api/${path}`,
      data: config.body ? config.body : undefined
    });
    return response.data.data;
  } catch (error) {
    if (error.response) {
      throw new Error(JSON.stringify(error.response.data.data));
    }
  }
};
